import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const LayerIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 118 111" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M82 44.0132L105 55.5L59 78.4737L13 55.5L36 44.0132M82 69.5395L105 81.0263L59 104L13 81.0263L36 69.5395M59 7L105 29.9737L59 52.9474L13 29.9737L59 7Z"
        stroke="currentColor"
        strokeWidth="11"
      />
    </svg>
  </StyledSvgIcon>
);
export default LayerIcon;

LayerIcon.propTypes = customIconsPropTypes;
